import { render, staticRenderFns } from "./ChatAutoTranslatePrompt.vue?vue&type=template&id=1ba58a62&scoped=true"
import script from "./ChatAutoTranslatePrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatAutoTranslatePrompt.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChatAutoTranslatePrompt.vue?vue&type=style&index=0&id=1ba58a62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba58a62",
  null
  
)

export default component.exports